import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { TooltipComponent } from './tooltip.component';

@NgModule({
  declarations: [
    TooltipComponent
  ],
  imports: [
    NgbModule,
    CommonModule,
    TranslateModule
  ],
  providers: [],
  exports: [
    TooltipComponent
  ]
})
export class TooltipModule { }
